import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import userService from '../services/userService';

export const useCurrentUser = () => {
  const { accounts, inProgress } = useMsal();
  const [currentUser, setCurrentUser] = useState({
    name: 'User',
    email: '',
    photoUrl: null,
    id: ''
  });

  useEffect(() => {
    if (accounts.length > 0 && inProgress === InteractionStatus.None) {
      const account = accounts[0];
      
      const userName = account.name || 
                      account.idTokenClaims?.name || 
                      account.idTokenClaims?.given_name || 
                      account.username || 
                      'User';
      
      const userEmail = account.username || 
                       account.idTokenClaims?.preferred_username || 
                       account.idTokenClaims?.email || 
                       '';

      const userId = account.homeAccountId || 
                    account.localAccountId || 
                    userEmail || 
                    'unknown-user';

      // Set basic user info first
      const newUserInfo = {
        name: userName,
        email: userEmail,
        id: userId,
        photoUrl: null // Will be updated separately
      };
      
      setCurrentUser(prev => ({
        ...prev,
        ...newUserInfo
      }));

      // Fetch user photo asynchronously without causing re-render of dependent components
      userService.getUserByEmail(userEmail).then(url => {
        if (url) {
          setCurrentUser(prev => {
            // Only update if the email hasn't changed (to avoid race conditions)
            if (prev.email === userEmail) {
              return {
                ...prev,
                photoUrl: url
              };
            }
            return prev;
          });
        }
      }).catch(err => {
        console.warn('Could not fetch user photo:', err);
      });
    }
  }, [accounts, inProgress]);

  return currentUser;
}; 